import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { CARBON_FORM_REDUCER_TOKEN, carbonFormReducerProvider, rootReducerKey } from './form.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CarbonFormEffects } from './form.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(rootReducerKey, CARBON_FORM_REDUCER_TOKEN),
    EffectsModule.forFeature([CarbonFormEffects])
  ],
  providers: [
    carbonFormReducerProvider
  ]
})
export class CarbonFormStoreModule { }
